import React from 'react';
import { WorkingStyleGridLegend } from '../../types';

interface WorkStylesLegendProps {
  legend: WorkingStyleGridLegend[];
}

const WorkStylesLegend = ({ legend }: WorkStylesLegendProps) => (
  <>
    {legend && legend?.length > 0 && (
      <section className="tw-flex tw-items-center tw-gap-4 tw-mb-8 tw-justify-center">
        {legend?.map(legendItem => (
          <div key={legendItem.name} className="tw-flex tw-items-center tw-gap-3">
            {legendItem.shape}
            <span className="tw-text-sm tw-font-medium tw-leading-5 tw-gray-700">
              {legendItem.name}
            </span>
          </div>
        ))}
      </section>
    )}
  </>
);

export default WorkStylesLegend;
